var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单退货退款",
        visible: _vm.dialogVisible,
        width: "500px",
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取　消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定提交")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.refundInfo
        ? _c(
            "el-form",
            {
              ref: "refundForm",
              attrs: {
                model: _vm.refundInfo,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号" } }, [
                _vm._v(_vm._s(_vm.refundInfo.orderNumber)),
              ]),
              _c("el-form-item", { attrs: { label: "支付单号" } }, [
                _vm._v(_vm._s(_vm.refundInfo.payNumber)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "退货原因", prop: "reasonId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "max-width",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择退货原因",
                      },
                      model: {
                        value: _vm.refundInfo.reasonId,
                        callback: function ($$v) {
                          _vm.$set(_vm.refundInfo, "reasonId", $$v)
                        },
                        expression: "refundInfo.reasonId",
                      },
                    },
                    _vm._l(_vm.refundReasons, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.explanation, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款说明", prop: "remark" } },
                [
                  _c("el-input", {
                    staticClass: "max-width",
                    attrs: { placeholder: "请输入退款说明", clearable: "" },
                    model: {
                      value: _vm.refundInfo.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.refundInfo, "remark", $$v)
                      },
                      expression: "refundInfo.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }